export function createDownloadFile(
  input: string | Uint8Array,
  name: string,
  extension: string,
  mimeType = 'text/plain'
) {
  const element = document.createElement('a');

  const data = typeof input === 'string' ? input : new Uint8Array(input);

  const file = new Blob([data], { type: mimeType });

  element.href = URL.createObjectURL(file);
  element.download = `${name}.${extension}`;

  // Required for FireFox
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
  URL.revokeObjectURL(element.href);
}
